export default function NoResultsIllustration() {
  return (
    <svg
      width="101"
      height="100"
      viewBox="0 0 101 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="57"
        cy="70"
        rx="18"
        ry="3"
        className="fill-neutral-200 dark:fill-neutral-800"
      />
      <path
        d="M44 47H35.8C32 47 29 43.9 29 40C29 36.1 32 33 35.8 33C36.1 33 36.5 33 36.8 33.1C37.2 29.6 40.1 27 43.5 27C46.7 27 49.3 29.2 50.1 32.2C50.6 32.1 51.2 32 51.7 32C55.8 32 59 35.4 59 39.5C59 40.6 58.8 41.6 58.4 42.5"
        className="stroke-neutral-300 dark:stroke-neutral-700"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 53C12.5 52.4 12.9 52 13.5 52L13.6 52C14.1 52 14.6 52.4 14.6 53C14.6 53.6 14.1 54 13.6 54L13.5 54C12.9 54 12.5 53.6 12.5 53ZM16.6 53C16.6 52.4 17 52 17.6 52L17.7 52C18.2 52 18.7 52.4 18.7 53C18.7 53.6 18.2 54 17.7 54L17.6 54C17 54 16.6 53.6 16.6 53ZM20.7 53C20.7 52.4 21.1 52 21.7 52L21.8 52C22.3 52 22.8 52.4 22.8 53C22.8 53.6 22.3 54 21.8 54L21.7 54C21.1 54 20.7 53.6 20.7 53ZM24.8 53C24.8 52.4 25.2 52 25.8 52L25.9 52C26.4 52 26.9 52.4 26.9 53C26.9 53.6 26.4 54 25.9 54L25.8 54C25.2 54 24.8 53.6 24.8 53ZM28.9 53C28.9 52.4 29.3 52 29.9 52L30 52C30.5 52 31 52.4 31 53C31 53.6 30.5 54 30 54L29.9 54C29.3 54 28.9 53.6 28.9 53ZM33 53C33 52.4 33.5 52 34 52L34.1 52C34.7 52 35.1 52.4 35.1 53C35.1 53.6 34.7 54 34.1 54L34 54C33.5 54 33 53.6 33 53ZM37.1 53C37.1 52.4 37.6 52 38.1 52L38.2 52C38.8 52 39.2 52.4 39.2 53C39.2 53.6 38.8 54 38.2 54L38.1 54C37.6 54 37.1 53.6 37.1 53ZM70 53C70 52.4 70.5 52 71 52L71.1 52C71.7 52 72.1 52.4 72.1 53C72.1 53.6 71.7 54 71.1 54L71 54C70.5 54 70 53.6 70 53ZM74.1 53C74.1 52.4 74.6 52 75.1 52L75.2 52C75.8 52 76.2 52.4 76.2 53C76.2 53.6 75.8 54 75.2 54L75.1 54C74.6 54 74.1 53.6 74.1 53ZM78.2 53C78.2 52.4 78.7 52 79.2 52L79.3 52C79.9 52 80.3 52.4 80.3 53C80.3 53.6 79.9 54 79.3 54L79.2 54C78.7 54 78.2 53.6 78.2 53ZM82.3 53C82.3 52.4 82.8 52 83.3 52L83.4 52C84 52 84.4 52.4 84.4 53C84.4 53.6 84 54 83.4 54L83.3 54C82.8 54 82.3 53.6 82.3 53ZM86.4 53C86.4 52.4 86.9 52 87.4 52L87.5 52C88.1 52 88.5 52.4 88.5 53C88.5 53.6 88.1 54 87.5 54L87.4 54C86.9 54 86.4 53.6 86.4 53Z"
        className="fill-neutral-300 dark:fill-neutral-700"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.6 52.8C67.6 54 67.4 55.1 67.1 56.2C66.6 57.9 66.9 59.8 68.1 61L71 63.9C72.3 65.3 72.3 67.6 71 68.9C69.6 70.3 67.3 70.3 65.9 68.9L63 66C61.8 64.8 59.9 64.6 58.2 65.1C57.1 65.4 56 65.6 54.8 65.6C47.7 65.6 42 59.9 42 52.8C42 45.7 47.7 40 54.8 40C61.9 40 67.6 45.7 67.6 52.8ZM54.8 61.6C59.7 61.6 63.6 57.7 63.6 52.8C63.6 47.9 59.7 43.9 54.8 43.9C49.9 43.9 45.9 47.9 45.9 52.8C45.9 57.7 49.9 61.6 54.8 61.6Z"
        className="fill-neutral-50 stroke-neutral-400 dark:fill-neutral-800 dark:stroke-neutral-600"
        strokeLinecap="round"
      />
      <circle cx="50.5" cy="48.5" r="1" className="fill-neutral-400" />
      <circle cx="52.5" cy="50.5" r="1" className="fill-neutral-400" />
      <circle cx="57" cy="55" r="1" className="fill-neutral-400" />
      <circle cx="59" cy="57" r="1" className="fill-neutral-400" />
      <circle cx="54.8" cy="52.8" r="1" className="fill-neutral-400" />
      <g className="fill-neutral-400">
        <circle cx="50.5" cy="57" r="1" transform="rotate(-90 50.5 57)" />
        <circle cx="52.5" cy="55" r="1" transform="rotate(-90 52.5 55)" />
        <circle cx="57" cy="50.5" r="1" transform="rotate(-90 57 50.5)" />
        <circle cx="59" cy="48.5" r="1" transform="rotate(-90 59 48.5)" />
        <circle cx="54.8" cy="52.8" r="1" transform="rotate(-90 54.8 52.8)" />
      </g>
    </svg>
  );
}
